export default __webpack_public_path__ + "static/media/how-it-works-3.e5f419ac.svg";